import { useEffect } from "react";

const defaultPageTitle = "Cadendar";
const defaultFaviconHref = "/patient-favicons/default.svg";

interface PatientPageMetadataOptions {
  name?: string;
  forename?: string;
}

export function getPatientFaviconHref(name: string | undefined) {
  const initial = name
    ?.trim()
    .replaceAll("Œ", "OE")
    .replaceAll("œ", "oe")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .charAt(0)
    .toUpperCase();

  return initial && /^[A-Z]$/.test(initial)
    ? `/patient-favicons/${initial}.svg`
    : defaultFaviconHref;
}

export function getPatientPageTitle({
  name,
  forename,
}: PatientPageMetadataOptions) {
  const formattedName = name?.trim().toUpperCase();
  const formattedForename = forename
    ?.trim()
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  const patientName = [formattedName, formattedForename]
    .filter(Boolean)
    .join(" ");

  return patientName
    ? `${patientName} - ${defaultPageTitle}`
    : defaultPageTitle;
}

export function usePatientPageMetadata({
  name,
  forename,
}: PatientPageMetadataOptions) {
  useEffect(() => {
    document.title = getPatientPageTitle({ name, forename });

    const favicon = document.getElementById("app-favicon");
    if (favicon instanceof HTMLLinkElement) {
      favicon.href = getPatientFaviconHref(name);
    }

    return () => {
      document.title = defaultPageTitle;
      if (favicon instanceof HTMLLinkElement) {
        favicon.href = defaultFaviconHref;
      }
    };
  }, [name, forename]);
}
